import Roles from '../models/roles'

interface IPerrmissions {
  Application: {

  }
  Agency: {
    manage: boolean
  }
  Project: {
    create: boolean
  }
  Post: {
    create: boolean
    makeRevision: boolean
    makeRevisionQuestion: boolean
    makeRevisionResponse: boolean
    approveInternalRound: boolean
    approveExternalRound: boolean
    seeInternalApprovalRound: boolean
    moveToApprovalList: boolean
    moveToUnapprovalList: boolean
  }
}

type TRolePermissions = {
  [key in Roles]: IPerrmissions
}

export const RolePermissions: TRolePermissions = {
  [Roles.SUPER_ADMIN]: {
    Application: {

    },
    Agency: {
      manage: true
    },
    Project: {
      create: true
    },
    Post: {
      create: true,
      makeRevision: true,
      makeRevisionQuestion: true,
      makeRevisionResponse: true,
      approveInternalRound: true,
      approveExternalRound: true,
      seeInternalApprovalRound: true,
      moveToApprovalList: true,
      moveToUnapprovalList: true
    }
  },
  [Roles.AGENCY_ADMIN]: {
    Application: {

    },
    Agency: {
      manage: true
    },
    Project: {
      create: true
    },
    Post: {
      create: true,
      makeRevision: true,
      makeRevisionQuestion: true,
      makeRevisionResponse: true,
      approveInternalRound: true,
      approveExternalRound: true,
      seeInternalApprovalRound: true,
      moveToApprovalList: true,
      moveToUnapprovalList: true
    }
  },
  [Roles.CONTENT_CREATOR]: {
    Application: {

    },
    Agency: {
      manage: true
    },
    Project: {
      create: false
    },
    Post: {
      create: true,
      makeRevision: true,
      makeRevisionQuestion: true,
      makeRevisionResponse: false,
      approveInternalRound: false,
      approveExternalRound: false,
      seeInternalApprovalRound: true,
      moveToApprovalList: false,
      moveToUnapprovalList: true
    }
  },
  [Roles.INTERNAL_APPROVER]: {
    Application: {

    },
    Agency: {
      manage: true
    },
    Project: {
      create: false
    },
    Post: {
      create: false,
      makeRevision: true,
      makeRevisionQuestion: false,
      makeRevisionResponse: true,
      approveInternalRound: true,
      approveExternalRound: false,
      seeInternalApprovalRound: true,
      moveToApprovalList: false,
      moveToUnapprovalList: true
    }
  },
  [Roles.EXTERNAL_APPROVER]: {
    Application: {
    },
    Agency: {
      manage: true
    },
    Project: {
      create: false
    },
    Post: {
      create: false,
      makeRevision: true,
      makeRevisionQuestion: false,
      makeRevisionResponse: true,
      approveInternalRound: false,
      approveExternalRound: true,
      seeInternalApprovalRound: false,
      moveToApprovalList: false,
      moveToUnapprovalList: true
    }
  }
}
